import { Middleware, configureStore, Action } from '@reduxjs/toolkit';
import { centralApi } from 'src/redux/services/centralApi';

interface IAction extends Action {
	payload?: {
		payload?: any
		http_message?: string
		frontend_message?: string
	}
}

const middleware: Middleware = _api => (next) => (action) => {
	//@ts-ignore
	if('payload' in action){
		const { payload, } = action as IAction;
		if(payload){
			const err = payload?.frontend_message;
			if(err){
				const _action = { ...action, payload: err, };
				return next(_action);
			}
	
			const unwrappedData = payload?.payload;
			if(unwrappedData){
				const _action = { ...action, payload: unwrappedData, };
				return next(_action);
			}
		}
	}

	return next(action);
};

export const store = configureStore({
	reducer: {
		[centralApi.reducerPath]: centralApi.reducer,
	},
	middleware: (getDefaultMiddleware) => {
		return getDefaultMiddleware().concat(centralApi.middleware, middleware);
	},

});

export type RootState = ReturnType<typeof store.getState>;
